"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mediaPlayerSettings", {
  enumerable: true,
  get: function get() {
    return _mediaPlayerSettings["default"];
  }
});
var _mediaPlayerSettings = _interopRequireDefault(require("./mediaPlayerSettings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }